module.exports = __webpack_public_path__ + "static/media/kitchen-2165756_1920.24194140.jpg";